import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../supabaseClient";

export default function TeacherLogin() {
  const navigate = useNavigate();
  const [checkingSession, setCheckingSession] = useState(true);
  // 1️⃣ CHECK EXISTING SESSION BEFORE SHOWING LOGIN
  useEffect(() => {
    async function checkSession() {
      const { data, error } = await supabase.auth.getSession();
      if (error || !data?.session) {
        setCheckingSession(false);
        return;
      }
      if (data.session) {
        navigate("/classroom", { replace: true });
        return;
      }
      setCheckingSession(false);
    }
    checkSession();
  }, [navigate]);

  if (checkingSession) {
    return <div className="min-h-screen bg-white" />; // blank while checking
  }

  async function loginWithAuthentik() {
    await supabase.auth.signInWithOidc();
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="bg-white shadow-xl rounded-2xl p-6 w-full max-w-md">

        <h1 className="text-2xl font-bold text-center mb-6">
          Inloggen voor leerkrachten
        </h1>

        <button
          onClick={loginWithAuthentik}
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700"
        >
          Inloggen met Authentik
        </button>
      </div>
    </div>
  );
}
